import * as actionTypes from './actions';

const initialState = {
    isLoading: false,
    allAdmins: {},
    admin: {},
}

export default function adminReducer(state = { ...initialState }, action) {

    switch (action.type) {
        case actionTypes.GET_ALL_ADMINS_REQUEST:
            return { ...state, isLoading: true }
        case actionTypes.GET_ALL_ADMINS_SUCCESS:
            return { ...state, isLoading: false, allAdmins: action.payload || {} }
        case actionTypes.GET_ALL_ADMINS_FAILED:
            return { ...state, isLoading: false }
        case actionTypes.GET_ADMIN_BY_ID_REQUEST:
            return { ...state, isLoading: true }
        case actionTypes.GET_ADMIN_BY_ID_SUCCESS:
            return { ...state, isLoading: false, admin: action.payload || {} }
        case actionTypes.GET_ADMIN_BY_ID_FAILED:
            return { ...state, isLoading: false }
        case actionTypes.DELETE_ADMIN_REQUEST:
            return { ...state, isLoading: true }
        case actionTypes.DELETE_ADMIN_SUCCESS:
            return { ...state, isLoading: false }
        case actionTypes.DELETE_ADMIN_FAILED:
            return { ...state, isLoading: false }
        case actionTypes.UPDATE_ADMIN_REQUEST:
            return { ...state, isLoading: true }
        case actionTypes.UPDATE_ADMIN_SUCCESS:
            return { ...state, isLoading: false }
        case actionTypes.UPDATE_ADMIN_FAILED:
            return { ...state, isLoading: false }
        case actionTypes.CREATE_ADMIN_REQUEST:
            return { ...state, isLoading: true }
        case actionTypes.CREATE_ADMIN_SUCCESS:
            return { ...state, isLoading: false }
        case actionTypes.CREATE_ADMIN_FAILED:
            return { ...state, isLoading: false }
        case actionTypes.CLEAR_ADMIN_DATA:
            return { ...state, admin: {} }
        default:
            return state
    }
}
